














































import { Component, Vue } from "vue-property-decorator";
import MainNavbar from "./MainNavbar.vue";
import SwitchlangHeader from "./SwitchlangHeader.vue";
import ApplicationStore from "./ApplicationStore.vue";
import DropdownUser from "./DropdownUser.vue";
import SelectCompany from "./SelectCompany.vue";
import { MerchantId } from "@/helper/userHelper";
import UserManual from "./UserManual.vue";

@Component({ components: { MainNavbar, SwitchlangHeader, ApplicationStore, DropdownUser, SelectCompany, UserManual } })
export default class Header extends Vue {
  private scrollOver = false;
  private lastScrollTop = 0;

  mounted() {
    window.addEventListener("scroll", this.HandleScroll);
  }
  public HandleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollTop > this.lastScrollTop) {
      // downscroll code
      this.scrollOver = false;
    } else if (currentScrollTop < this.lastScrollTop) {
      // upscroll code
      this.scrollOver = window.scrollY > 110;
    }
    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }
  public ToHomePage() {
    this.$router.push({
      name: "home",
      query: { emi: MerchantId().PeakEncryption() },
    });
  }
}
